// /pages/wishlist の中身をクライアント側で組み立てる（plan §4.3）。
// cornier-wishlist.js（ボタンの共通ロジック）とは別ファイル：このページでしか
// 使わない一覧描画ロジックを他ページの読み込みに含めないため。
//
// 3つのモードがある:
//   own    - ログイン中の本人。/a/wishlist/list を叩く。削除ボタン・共有ボタンあり
//   shared - URLに ?share=token がある。/a/wishlist/shared-list を叩く（誰でも
//            閲覧可、ログイン不要）。削除・共有ボタンなし（閲覧専用）
//   login  - 上記どちらでもない。ログインを促す
(function () {
  'use strict';

  // gyomu「日本語からAI翻訳」の言語コード → Shopify request.locale.iso_code の対応。
  // 一致しない(日本語や未対応言語)場合は基本値(日本語)のまま。
  function translationLocaleKey() {
    var iso = (document.body.getAttribute('data-locale') || '').toLowerCase();
    if (iso === 'en') return 'en';
    if (iso === 'ko') return 'ko';
    if (iso === 'fr') return 'fr';
    if (iso === 'zh-cn' || iso === 'zh') return 'zh-CN';
    return null;
  }

  // 管理タブ(gyomu /wishlist 設定)で編集した文言。テーマエディタの section.settings が
  // デフォルト値、DB設定(wl_settings)があれば上書きする。さらに現在の言語に
  // AI翻訳(wl_settings.translations)があればそれで上書きする
  // （owner はもうgyomuだけ触ればいい）。
  var configPromise = fetch('/a/wishlist/config')
    .then(function (r) {
      if (!r.ok) throw new Error('config failed');
      return r.json();
    })
    .then(function (cfg) {
      var key = translationLocaleKey();
      var t = key && cfg.translations ? cfg.translations[key] : null;
      if (!t) return cfg;
      var merged = {};
      for (var k in cfg) merged[k] = cfg[k];
      for (var tk in t) {
        if (t[tk]) merged[tk] = t[tk];
      }
      return merged;
    })
    .catch(function () {
      return {};
    });

  function rootUrl() {
    // routes.root_url はデフォルトマーケットだと "/" を返す。そのまま
    // '/products/...' と連結すると "//products/..." になり、ブラウザが
    // プロトコル相対URL（別ホスト）と誤解釈してfetchが全滅する
    // (owner報告 2026-09-09: 販売終了と誤表示される)。末尾のスラッシュは必ず落とす。
    var v = document.body.getAttribute('data-root-url') || '';
    return v.replace(/\/+$/, '');
  }

  function getShareToken() {
    try {
      return new URLSearchParams(window.location.search).get('share');
    } catch (e) {
      return null;
    }
  }

  // gyomu管理画面(WISHLIST > 設定 > 色)の残り在庫わずかバッジ色設定を反映。
  // 未設定(null)ならCSS側のデフォルト値(var()の第2引数)のまま。
  function applyLowStockBadgeColors(cfg) {
    var root = document.documentElement.style;
    if (cfg.lowStockBadgeBg) root.setProperty('--cornier-wl-lowstock-bg', cfg.lowStockBadgeBg);
    if (cfg.lowStockBadgeTextColor) root.setProperty('--cornier-wl-lowstock-text', cfg.lowStockBadgeTextColor);
    if (cfg.lowStockBadgeBorderColor) root.setProperty('--cornier-wl-lowstock-border', cfg.lowStockBadgeBorderColor);
  }

  document.addEventListener('DOMContentLoaded', function () {
    configPromise.then(function (cfg) {
      applyLowStockBadgeColors(cfg);
      var title = document.querySelector('[data-wl-page-title]');
      if (title && cfg.pageTitle) title.textContent = cfg.pageTitle;
      var login = document.querySelector('[data-wl-page-login-prompt]');
      if (login && cfg.loginPrompt) login.textContent = cfg.loginPrompt;

      var root = document.documentElement.style;
      if (cfg.addAllIconColor) root.setProperty('--cornier-wl-addall-icon', cfg.addAllIconColor);
    });

    var root = document.querySelector('[data-wl-page-root]');
    var loginBlock = document.querySelector('[data-wl-page-login-required]');
    var shareBar = document.querySelector('[data-wl-page-share-bar]');
    var sharedBanner = document.querySelector('[data-wl-page-shared-banner]');

    var shareToken = getShareToken();
    var customerId = document.body.getAttribute('data-customer');
    customerId = customerId && customerId !== '' ? customerId : null;

    if (shareToken) {
      loadShared(shareToken, root, sharedBanner);
      return;
    }

    if (!customerId) {
      if (loginBlock) loginBlock.hidden = false;
      return;
    }

    if (root) root.hidden = false;
    if (shareBar) {
      shareBar.hidden = false;
      bindShareButton(shareBar, document.querySelector('[data-wl-page-share-panel]'));
    }
    var refreshBtn = document.querySelector('[data-wl-page-refresh]');
    if (refreshBtn) {
      refreshBtn.hidden = false;
      bindRefreshButton(refreshBtn, root);
    }

    loadOwnList(root);
  });

  // ボタンを押した直後・reload直後の1回だけ呼ぶ。一覧を丸ごと描画し直す
  // （更新ボタンからも同じ経路を使う）。カード1枚1枚の商品情報取得まで
  // 終わったタイミングでresolveする(更新ボタンのスピナーを止めるため)。
  function loadOwnList(root) {
    return fetch('/a/wishlist/list', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('list failed');
        return r.json();
      })
      .then(function (data) {
        return renderList(root, data.items || [], { readOnly: false });
      })
      .catch(function () {
        root.innerHTML = '<p class="cornier-wl-page__empty">読み込みに失敗しました。時間をおいて再度お試しください。</p>';
      });
  }

  // 「リストを更新」ボタン。カードのハートを押した直後は一覧を自動では
  // 並べ替えない(owner指示2026-09-16: 外す→すぐ入れ直すの連打で表示と実際の
  // 状態がズレるレースが起きていたため、即時のカード削除自体をやめた)。
  // 反映はこのボタンかreloadを押した時だけ。処理中はアイコンを回して
  // 分かるようにする(owner指示2026-09-16)。
  function bindRefreshButton(btn, root) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-refreshing');
      if (window.CornierWishlist) window.CornierWishlist.refreshAllButtons();
      loadOwnList(root).then(function () {
        btn.disabled = false;
        btn.classList.remove('is-refreshing');
      });
    });
  }

  function loadShared(token, root, sharedBanner) {
    if (root) root.hidden = false;
    var bannerText = sharedBanner && sharedBanner.querySelector('[data-wl-page-shared-banner-text]');
    var addAllBtn = sharedBanner && sharedBanner.querySelector('[data-wl-page-add-all]');
    var addAllLabel = addAllBtn && addAllBtn.querySelector('[data-wl-page-add-all-label]');
    if (sharedBanner) sharedBanner.hidden = false;

    if (bannerText) {
      configPromise.then(function (cfg) {
        bannerText.textContent = cfg.sharedBannerText || '共有されたお気に入りです（閲覧のみ）';
      });
    }

    fetch('/a/wishlist/shared-list?token=' + encodeURIComponent(token), { credentials: 'omit' })
      .then(function (r) {
        if (r.status === 404 || r.status === 410) {
          var err = new Error('expired');
          err.expired = true;
          throw err;
        }
        if (!r.ok) throw new Error('failed');
        return r.json();
      })
      .then(function (data) {
        var items = data.items || [];
        renderList(root, items, { readOnly: true });
        var addable = items.filter(function (it) {
          return !!it.variant_id;
        });
        if (addAllBtn && addable.length > 0) {
          addAllBtn.hidden = false;
          bindAddAllButton(addAllBtn, addable);
        }
      })
      .catch(function (e) {
        if (sharedBanner) sharedBanner.hidden = true;
        if (root) {
          root.innerHTML =
            '<p class="cornier-wl-page__empty">' +
            (e && e.expired
              ? 'このリンクは無効です。トップページへ移動します…'
              : '読み込みに失敗しました。時間をおいて再度お試しください。') +
            '</p>';
        }
        if (e && e.expired) {
          setTimeout(function () {
            window.location.href = rootUrl() || '/';
          }, 3000);
        }
      });
  }

  // 「全てのアイテムをMy wishlistに追加する」⇔「…から削除する」。閲覧者自身の
  // お気に入りに、共有アイテムが全件すでに入っているかどうかでボタンの
  // 文言と挙動を切り替える(owner指示2026-09-09)。未ログインなら常に「追加」
  // 表示のままログインへ誘導する(既存のpending-add機構は1件専用のため
  // 一括分は追従しない)。
  function bindAddAllButton(btn, items) {
    var label = btn.querySelector('[data-wl-page-add-all-label]');
    var iconsWrap = btn.querySelector('.cornier-wl-page__add-all-icons');
    var mode = 'add';

    function getCustomerId() {
      var v = document.body.getAttribute('data-customer');
      return v && v !== '' ? v : null;
    }

    function applyLabel(cfg, nextMode) {
      mode = nextMode;
      // アイコンの見た目(白地黒線⇔黒地白線)は「押した回数」ではなく実際の状態
      // (全件Wishlisted済みか)と一致させる(owner指摘2026-09-10: クリックごとの
      // トグルだと表示とアイテムの実際の状態がズレる)
      if (iconsWrap) iconsWrap.classList.toggle('is-pressed', nextMode === 'remove');
      if (!label) return;
      label.textContent =
        nextMode === 'remove'
          ? cfg.sharedRemoveAllText || 'すべてのアイテムを自分のWishlistから削除する'
          : cfg.sharedAddAllText || 'すべてのアイテムをお気に入りに追加する';
    }

    function refreshMode() {
      configPromise.then(function (cfg) {
        var customerId = getCustomerId();
        if (!customerId) {
          applyLabel(cfg, 'add');
          return;
        }
        fetch('/a/wishlist/list', { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('list failed');
            return r.json();
          })
          .then(function (data) {
            var ownItems = data.items || [];
            var allWishlisted = items.every(function (it) {
              return ownItems.some(function (ownIt) {
                return (
                  ownIt.product_handle === it.product_handle &&
                  String(ownIt.variant_id) === String(it.variant_id)
                );
              });
            });
            applyLabel(cfg, allWishlisted ? 'remove' : 'add');
          })
          .catch(function () {
            applyLabel(cfg, 'add');
          });
      });
    }

    refreshMode();

    // カード側の個別トグルボタンをクリックした後もモードを再評価する。
    // 固定500ms待ちだと、トースト(追加/削除しました)が先に出てからこの
    // アイコンが遅れて変わって見える(owner報告2026-09-16)。実際にAPI呼び出し
    // が終わった瞬間(トーストと同じタイミング)に発火する
    // cornier-wishlist:toggled を使い、タイマー予測ではなく実処理完了に合わせる
    document.addEventListener('cornier-wishlist:toggled', refreshMode);

    btn.addEventListener('click', function () {
      var customerId = getCustomerId();
      if (!customerId) {
        var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = '/account/login?return_url=' + returnUrl;
        return;
      }

      var actionMode = mode;
      var action = actionMode === 'remove' ? 'remove' : 'add';

      btn.disabled = true;
      var original = label ? label.textContent : '';
      if (label) label.textContent = actionMode === 'remove' ? '削除中…' : '追加中…';

      Promise.all(
        items.map(function (it) {
          return fetch('/a/wishlist/' + action, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ handle: it.product_handle, variant_id: it.variant_id }),
          }).catch(function () {});
        })
      ).then(function () {
        if (label) label.textContent = actionMode === 'remove' ? '削除しました' : '追加しました';
        // アイコンはrefreshMode()の再取得(/a/wishlist/list)を待つとネットワーク
        // 往復ぶん遅れてトースト文言より後に色が変わる(owner報告2026-09-16)。
        // 今実行したのが全件add/removeである以上、次の状態は自明なので
        // 再取得を待たずその場で確定させる。
        configPromise.then(function (cfg) {
          applyLabel(cfg, actionMode === 'remove' ? 'add' : 'remove');
        });
        // カード側の個別ハートも同じ理由で自明な結果を再取得なしに反映する
        // (refreshAllButtons()の/a/wishlist/list再取得を待つと二重ハートより
        // 数秒遅れて見える、owner報告2026-09-16)
        if (window.CornierWishlist && window.CornierWishlist.setAllButtonsActive) {
          window.CornierWishlist.setAllButtonsActive(action === 'add');
        } else if (window.CornierWishlist) {
          window.CornierWishlist.refreshAllButtons();
        }
        setTimeout(function () {
          if (label && label.textContent === (actionMode === 'remove' ? '削除しました' : '追加しました')) {
            label.textContent = original;
          }
          btn.disabled = false;
        }, 2000);
      });
    });
  }

  function bindShareButton(shareBar, panel) {
    var btn = shareBar.querySelector('[data-wl-page-share-btn]');
    if (!btn || !panel) return;
    var urlInput = panel.querySelector('[data-wl-page-share-url]');
    var copyBtn = panel.querySelector('[data-wl-page-share-copy]');
    var reissueBtn = panel.querySelector('[data-wl-page-share-reissue]');
    var note = panel.querySelector('[data-wl-page-share-note]');

    var requested = false;

    // action: 'share' = 既存URLがあればそれを返す(初回のみ新規発行)。
    // 'share-new' = 既存を無視して常に新しいURLへ差し替える(古いURLは即無効)。
    function fetchShare(action, triggerBtn) {
      if (triggerBtn) triggerBtn.disabled = true;
      return fetch('/a/wishlist/' + action, { method: 'POST', credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('share failed');
          return r.json();
        })
        .then(function (data) {
          var url = window.location.origin + rootUrl() + '/pages/wishlist?share=' + encodeURIComponent(data.token);
          if (urlInput) urlInput.value = url;
          if (note) note.textContent = '';
        })
        .catch(function () {
          if (note) note.textContent = 'URLの発行に失敗しました。時間をおいて再度お試しください。';
        })
        .finally(function () {
          if (triggerBtn) triggerBtn.disabled = false;
        });
    }

    btn.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      if (panel.hidden || requested) return;
      requested = true;
      fetchShare('share', btn);
    });

    if (reissueBtn) {
      reissueBtn.addEventListener('click', function () {
        if (!window.confirm('新しいURLを発行すると、今のURLは無効になります。よろしいですか？')) return;
        fetchShare('share-new', reissueBtn);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (!urlInput || !urlInput.value) return;
        navigator.clipboard
          .writeText(urlInput.value)
          .then(function () {
            copyBtn.classList.add('cornier-wl-page__share-copy--done');
            copyBtn.setAttribute('aria-label', 'コピーしました');
            setTimeout(function () {
              copyBtn.classList.remove('cornier-wl-page__share-copy--done');
              copyBtn.setAttribute('aria-label', 'コピー');
            }, 1500);
          })
          .catch(function () {
            urlInput.select();
          });
      });
    }
  }

  function cloneTemplate(selector) {
    var tpl = document.querySelector(selector);
    return tpl ? tpl.content.cloneNode(true) : null;
  }

  // 呼び出し元(更新ボタン)がスピナーを止めるタイミングを取れるよう、
  // カード全部の商品情報取得が終わった時点でresolveするPromiseを返す。
  function renderList(root, items, opts) {
    if (items.length === 0) {
      var empty = cloneTemplate('[data-wl-page-empty-template]');
      root.innerHTML = '';
      if (empty) root.appendChild(empty);
      configPromise.then(function (cfg) {
        var emptyText = root.querySelector('[data-wl-page-empty-text]');
        if (emptyText && cfg.pageEmptyText) emptyText.textContent = cfg.pageEmptyText;
      });
      return Promise.resolve();
    }

    // カード(商品情報・画像・ハートの状態)が全部そろうまで画面に出さず、
    // 非表示の作業用コンテナに組み立ててから1回で差し替える（owner指示2026-10-30:
    // 商品が先に出てハートが後から出る段階表示をやめる）。待っている間は
    // 既存の表示(初回は読み込みバー、更新時は旧一覧)をそのまま残す。
    var gridWrap = cloneTemplate('[data-wl-page-grid-template]');
    var stage = document.createElement('div');
    stage.appendChild(gridWrap);
    var grid = stage.querySelector('[data-wl-page-grid]');

    var pending = items.map(function (item) {
      return renderCard(grid, item, opts);
    });

    return Promise.all(pending).then(function () {
      // ハートの色設定(CSS変数)の適用が済んでから表示する(後から色が変わるのを防ぐ)
      return window.CornierWishlist && window.CornierWishlist.ready ? window.CornierWishlist.ready() : null;
    }).then(function () {
      root.innerHTML = '';
      while (stage.firstChild) root.appendChild(stage.firstChild);
      grid = root.querySelector('[data-wl-page-grid]');
      if (window.CornierWishlist) window.CornierWishlist.refreshAllButtons();
      // アーカイブ/非公開で隠れたカードがあると、一覧の実数とヘッダーの件数
      // バッジ(全wl_itemsの生カウント)がズレる(owner報告2026-09-16: 一覧3件
      // なのにバッジは4のまま)。全カードの生死が判明してから、このページの
      // バッジだけ実際に見えている枚数に合わせ直す
      if (opts.readOnly) return;
      var count = grid.querySelectorAll('.cornier-wl-card').length;
      var badges = document.querySelectorAll('[data-wl-badge]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = count > 0 ? String(count) : '';
        badges[i].hidden = count === 0;
      }
    });
  }

  function renderCard(grid, item, opts) {
    var cardFrag = cloneTemplate('[data-wl-page-card-template]');
    if (!cardFrag) return Promise.resolve();
    var cardEl = cardFrag.querySelector('.cornier-wl-card');
    grid.appendChild(cardFrag);

    return fetch(rootUrl() + '/products/' + item.product_handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('404');
        return r.json();
      })
      .then(function (product) {
        fillCard(cardEl, product, item, opts);
        applyLowStockBadge(cardEl, item);
        return waitImage(cardEl.querySelector('[data-wl-card-image]'));
      })
      .catch(function () {
        // 404 = 商品がアーカイブ済み、またはOnline Storeチャネルから非公開に
        // なった。Wishlistには残っていても一覧からは隠す。再公開されれば
        // 次のリスト更新で普通に出てくる（owner指示2026-09-16）
        cardEl.remove();
      });
  }

  // 画像の読み込み完了を待つ（失敗・遅延でも一覧全体を止めないよう最大4秒で打ち切る）
  function waitImage(img) {
    if (!img || !img.getAttribute('src') || img.complete) return Promise.resolve();
    return new Promise(function (resolve) {
      var done = function () { resolve(); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(done, 4000);
    });
  }

  function fillCard(cardEl, product, item, opts) {
    var link = cardEl.querySelector('[data-wl-card-link]');
    var titleLink = cardEl.querySelector('[data-wl-card-title-link]');
    var img = cardEl.querySelector('[data-wl-card-image]');
    var title = cardEl.querySelector('[data-wl-card-title]');
    var variantLabel = cardEl.querySelector('[data-wl-card-variant]');
    var price = cardEl.querySelector('[data-wl-card-price]');
    var sizeSelect = cardEl.querySelector('[data-wl-card-size-select]');
    var soldout = cardEl.querySelector('[data-wl-card-soldout]');

    var variant = null;
    if (item.variant_id) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(item.variant_id)) {
          variant = product.variants[i];
          break;
        }
      }
    }
    var url = rootUrl() + '/products/' + product.handle + (variant ? '?variant=' + variant.id : '');
    if (link) link.href = url;
    if (titleLink) titleLink.href = url;
    // 画像なし商品はsrcが一生付かずシマーが回り続けるため、静かな背景だけに
    // 止める（CSS側は :not([src]) をシマー扱いにしている、owner報告2026-09-16）。
    if (img) {
      if (product.featured_image) img.src = product.featured_image;
      else img.classList.add('cornier-wl-card__image--no-image');
    }
    if (title) title.textContent = product.title;
    if (variantLabel) {
      if (variant && variant.title && variant.title !== 'Default Title') {
        variantLabel.textContent = variant.title;
        variantLabel.hidden = false;
      } else {
        variantLabel.hidden = true;
      }
    }
    if (price) {
      var amount = variant ? variant.price : product.price;
      price.textContent = formatPriceDisplay(amount);
    }
    if (soldout) soldout.hidden = !(variant && variant.available === false);

    if (opts && opts.readOnly) {
      // 共有(閲覧専用)ページ: 見ている本人の持ち物ではないため、ここのサイズ選択で
      // /a/wishlist/set-variant を叩くと共有元(オーナー)のデータを誤って書き換える。
      // variant確定済みのアイテムだけ「Wishlist」ボタンを出し、閲覧者自身の
      // お気に入りに追加できるようにする（未確定はボタンごと出さない＝サイズ選択UI不要）。
      var wlBtn = cardEl.querySelector('[data-wl-toggle]');
      if (wlBtn && item.variant_id) {
        wlBtn.setAttribute('data-wl-handle', item.product_handle);
        wlBtn.setAttribute('data-wl-variant', String(item.variant_id));
        wlBtn.hidden = false;
      }
      return;
    }

    // 自分のWishlistページ: このカードは既に登録済みなので、Wishlistボタンは
    // 常に表示（塗りハート＝登録中）。押して解除してもカード自体はこの場では
    // 消さず、アイコンだけ変える（誤タップした時にすぐ戻せるように）。実際に
    // 一覧から消えるのは「リストを更新」ボタンかreloadを押した時だけ
    // (owner指示2026-09-16)。
    var ownWlBtn = cardEl.querySelector('[data-wl-toggle]');
    if (ownWlBtn) {
      ownWlBtn.setAttribute('data-wl-handle', item.product_handle);
      ownWlBtn.setAttribute('data-wl-variant', item.variant_id ? String(item.variant_id) : '');
      ownWlBtn.hidden = false;
      // 自分の一覧に載っているカードは登録済みと分かっているので、/list の再取得を
      // 待たずに塗りハートで先に確定させる（差し替え後のrefreshで同じ状態に上書きされる）
      ownWlBtn.classList.add('is-active', 'wl-ready');
      ownWlBtn.setAttribute('aria-pressed', 'true');
    }

    if (!item.variant_id && sizeSelect && product.variants.length > 1) {
      sizeSelect.hidden = false;
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'サイズを選択';
      sizeSelect.appendChild(placeholder);
      product.variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        sizeSelect.appendChild(opt);
      });
      sizeSelect.addEventListener('change', function () {
        if (!sizeSelect.value) return;
        fetch('/a/wishlist/set-variant', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: item.product_handle, variant_id: sizeSelect.value }),
        }).then(function () {
          sizeSelect.hidden = true;
          var chosenUrl = rootUrl() + '/products/' + product.handle + '?variant=' + sizeSelect.value;
          if (link) link.href = chosenUrl;
          if (titleLink) titleLink.href = chosenUrl;
          if (variantLabel) {
            var chosen = sizeSelect.options[sizeSelect.selectedIndex];
            variantLabel.textContent = chosen ? chosen.textContent : '';
            variantLabel.hidden = !chosen;
          }
        });
      });
    }
  }

  // 「残り在庫わずか」バッジ。gyomu /a/wishlist/list が low_stock:true を返した
  // アイテムだけ対象（管理タブでON+しきい値設定済みの時のみ返る、owner要望2026-09-15）。
  // 売り切れ表示と同じ左上枠を使うため、soldoutが出ている時は出さない（排他）。
  function applyLowStockBadge(cardEl, item) {
    if (!item.low_stock) return;
    var badge = cardEl.querySelector('[data-wl-card-lowstock]');
    var soldout = cardEl.querySelector('[data-wl-card-soldout]');
    if (!badge || (soldout && !soldout.hidden)) return;
    configPromise.then(function (cfg) {
      badge.textContent = cfg.lowStockBadgeText || '残り在庫わずか';
      badge.hidden = false;
    });
  }

  function formatMoneyJPY(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  // JP以外は選択中マーケットの通貨で表示する。rootUrl()を付けてfetchした時点で
  // cents は既にそのマーケットの通貨換算後の金額になっている
  // (window.Shopify.currency.active はDawnのテーマがマーケット選択時に自動セットする)。
  // 通貨記号を¥固定にしていたため「韓国選択中でも¥表示」になっていたのがバグの原因。
  function formatMoneyLocalized(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JPY';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return currency + ' ' + Math.round(cents / 100).toLocaleString();
    }
  }

  // snippets/price.liquid と同じ表示規則: JPは税抜き価格をメインに、
  // カッコで税込みを添える。それ以外の地域は税抜き価格のみ
  function formatPriceDisplay(cents) {
    if (document.body.getAttribute('data-locale-jp') === 'true') {
      var nonTaxedCents = Math.round((cents * 10) / 11);
      return formatMoneyJPY(nonTaxedCents) + ' (' + formatMoneyJPY(cents) + ' tax in)';
    }
    return formatMoneyLocalized(cents);
  }
})();
